import React from 'react';
import PropTypes from 'prop-types';

const AccessibilityNot = ({ color = '#BCC6CA', fillColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      d="M15.193 16.29a5.96 5.96 0 0 1-.878 3.475 6.331 6.331 0 0 1-2.743 2.423 6.67 6.67 0 0 1-3.685.552 6.55 6.55 0 0 1-3.384-1.503 6.123 6.123 0 0 1-1.943-3.053 5.919 5.919 0 0 1 .154-3.574 6.182 6.182 0 0 1 2.198-2.889 6.595 6.595 0 0 1 3.502-1.231"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.7}
      d="M13.36 16.39a4.257 4.257 0 0 1-.627 2.482 4.522 4.522 0 0 1-1.96 1.73 4.765 4.765 0 0 1-2.632.395 4.678 4.678 0 0 1-2.417-1.074 4.373 4.373 0 0 1-1.387-2.18 4.228 4.228 0 0 1 .11-2.553c.299-.822.845-1.54 1.57-2.063a4.711 4.711 0 0 1 2.501-.88"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      d="m9 5.5 1.466 8.118a1 1 0 0 0 .985.822h5.591a1 1 0 0 1 .975.778l1.147 5.044a1 1 0 0 0 .975.778h1.481"
    />
    <path fill={color} d="M15.59 9.191a.5.5 0 1 0-.033-1l.033 1Zm-5.574.182 5.574-.182-.033-1-5.573.182.032 1Z" />
    <path
      fill={fillColor}
      stroke={color}
      d="M11.007 3.64c0 1.162-.99 2.14-2.254 2.14S6.5 4.802 6.5 3.64c0-1.162.989-2.14 2.253-2.14 1.265 0 2.254.978 2.254 2.14Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={fillColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

AccessibilityNot.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string
};

export default AccessibilityNot;
